import { Component } from 'react';
import { Button, Text, Img } from '../../Atoms';
import deconnectionImg from '../../assets/img/deconnecter.png';
import KeycloakService from '../../Services/KeycloakService';
import OrganismePhotoLogout from '../../Organisms/OrganismePhotoLogout/OrganismePhotoLogout';
class Deconnection extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div className="login-template">
      
        <div className="deconnection-container" style={{ margin: 'auto' }}>
          <div>
            <Text className="w-75" text="Vous avez été deconnecté." type="h4" />
            <div className="mt-30">
              <div className="btn-confirme-first-login-container deconnection-btn__edit-margin">
                <Button
                  text="Connexion"
                  className="btn-next-first-login"
                  boxShadow
                  onClick={() => KeycloakService.doLogin()}
                />
              </div>
            </div>
          </div>
        </div>
          <OrganismePhotoLogout />
      </div>
    );
  }
}
export default Deconnection;
